import React, { Component } from 'react'
import { Button, Table } from 'reactstrap';
import { Link } from 'react-router-dom'
import { find_evaluation } from '../../config/evaluations'
import { Trans } from "react-i18next";
import MoreScale from '../MoreScale'
import Tooltip from '../Tooltip'

class Assesments extends Component {

	constructor(props) {
		super(props);
	}


	render() {
		const { accounts, report_type } = this.props

		const keys = (report_type == 'complete' ? [
			{ name: 'closing_date', childs: [{ name: 'confidence', type: 'number' }] },
			{ name: 'solvency_ratios', childs: ['leverage_ratio', 'total_asset_total_liabilities_ratio'] },
			{ name: 'liquidity_ratios', childs: ['current_ratio', 'quick_ratio', 'cash_cycle_ratio'] },
			{ name: 'profitability_ratios', childs: ['roi_ratio', 'roe_ratio', 'asset_turnover_ratio', 'ebitda_sales_ratio'] },
			{ name: 'interest_coverage_ratios', childs: ['ebit_interest_coverage_ratio', 'ebitda_interest_coverage_ratio'] }
		] : [
			{ name: 'closing_date', childs: ['leverage_ratio', 'current_ratio', 'roe_ratio'] }
		])


		return <React.Fragment>
			<Table striped className="table-assesment">
				<tbody>
					{keys.map(k =>
						<React.Fragment key={k.name}>

							<tr>
								<th><Trans>assessments.{k.name}</Trans></th>
								{accounts.filter(a => a.assessment).map(a => <th key={a.closing_date}><i><Trans values={{ value: a.closing_date }}>standard_formatting.date</Trans></i></th>)}
							</tr>

							{k.childs.map(k =>
								<tr key={typeof (k) === 'string' ? k : k.name}>
									<td style={{ paddingLeft: '20px' }}>
										<Trans>assessments.{typeof (k) === 'string' ? k : k.name}.title</Trans>
					    &nbsp;
				<Tooltip title={<Trans>assessments.{typeof (k) === 'string' ? k : k.name}.hint</Trans>}><i className="fas fa-info-circle no-print"></i></Tooltip>
									</td>
									{accounts.filter(a => a.assessment).map(a => {
										if (typeof (k) === 'string')
											return <td key={a.closing_date}>

												<div>
													<b>{k && a.assessment != null && a.assessment[k + '_score'] != null ? <span>
														<i className="fa fa-circle" style={{ color: find_evaluation({ score: a.assessment[k + '_score'] }).color, fontSize: '7px' }}></i> &nbsp;
							{find_evaluation({ score: a.assessment[k + '_score'] }).letter}</span> : '-'}</b>
						  &nbsp;
					{report_type == 'complete' && <small className="pull-right">(<Trans values={{ value: (a.ratios != null && a.ratios[k] != null ? a.ratios[k] / 100 : null) }}>standard_formatting.percentage</Trans>)</small>}
												</div>

											</td>
										else
											return <td key={a.closing_date}>
												<div>{ isNaN(a.assessment[k.name]) ? '-' : <Trans values={{ value: a.assessment[k.name] / 100 }}>standard_formatting.percentage</Trans>}</div>
											</td>

									})}
								</tr>
							)}
						</React.Fragment>
					)}
				</tbody>
			</Table>
			<MoreScale />
		</React.Fragment>
	}
}

Assesments.defaultProps = {
	accounts: [],
	report_type: 'complete'
}
export default Assesments
